import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";


export class PricePlanStateSelectComponent implements IController {
  data: any;
  enableParentOption: boolean;
  showText: boolean;
  onChange: Function;

  $onInit() {
    if (_.isUndefined(this.enableParentOption)) {
      this.enableParentOption = true;
    }
  }

  changeStateTo(state) {
    _.isUndefined(state) ? _.unset(this.data, 'enabled') : _.set(this.data, 'enabled', state);
    this.onChange({data: this.data});
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanStateSelect', {
    bindings: {
      data: '<',
      enableParentOption: '<?',
      showText: '<?',
      onChange: '&'
    },
    template: require('./price-plan-state-select.html').default,
    controller: PricePlanStateSelectComponent
  });
